module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-SemiboldItalic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-SemiboldItalic-webfont.eot
// module id = 365
// module chunks = 0